export default __webpack_public_path__ + "static/media/NoshowIcon.b8abc545.svg";